let abortController = new AbortController();
export const handleSearch = () => {
  // Cancel the previous request
  abortController.abort();

  // Create a new AbortController for the current request
  abortController = new AbortController();
  return abortController;
};  